import { render, staticRenderFns } from "./sec-contacto.vue?vue&type=template&id=22c762f7&scoped=true&"
import script from "./sec-contacto.vue?vue&type=script&lang=js&"
export * from "./sec-contacto.vue?vue&type=script&lang=js&"
import style0 from "./sec-contacto.vue?vue&type=style&index=0&id=22c762f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c762f7",
  null
  
)

export default component.exports